module.exports = __webpack_public_path__ + "img/fosunWithdraw.551b6ce4.png";